<template>
  <div class="bg-primary rounded-md w-fit p-1">
    <Icon :size="IconSize.LG" :name="IconName.AWARD" class="text-on-primary" />
  </div>
</template>
<script setup lang="ts">
import { Icon, IconName, IconSize } from '@exfluential/ui';
</script>
